var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6701 5.88543C11.6701 8.82843 8.44016 11.8934 7.35555 12.84C7.14798 12.9978 6.8622 12.9978 6.65463 12.84C5.57002 11.8934 2.34009 8.82843 2.34009 5.88543C2.34009 3.2812 4.42868 1.17004 7.00509 1.17004C9.5815 1.17004 11.6701 3.2812 11.6701 5.88543Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.82996C5.25 4.86346 6.0335 4.07996 7 4.07996C7.9665 4.07996 8.75 4.86346 8.75 5.82996C8.75 6.79645 7.9665 7.57996 7 7.57996C6.0335 7.57996 5.25 6.79645 5.25 5.82996Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocc);
export default __webpack_public_path__ + "static/media/locc.e388de94313a27c6d32cb29d9a7652ac.svg";
export { ForwardRef as ReactComponent };